import PropTypes from "prop-types";
import DrugCategoryButton from "./DrugCategoryButton";
import styles from "./DrugCategoriesIndex.module.scss";

/**
 * Displays an alphabetical index of available drug categories for pregnancy and breastfeeding.
 */
const DrugCategoriesIndex = ({ categories, onCategoryClick, activeCategory = null }) => {
  if (!categories || categories.length === 0) {
    return null;
  }

  const availableCategories = categories.filter((category) => category.isAvailable);

  if (availableCategories.length === 0) {
    return null;
  }

  return (
    <div className={styles.drugCategoriesIndex}>
      <div className={styles.header}>
        <h3 className={styles.title}>A-Z index</h3>
      </div>

      <div className={styles.buttonGrid}>
        {availableCategories.map((category) => (
          <DrugCategoryButton
            key={category.letter}
            letter={category.letter}
            isActive={activeCategory === category.letter}
            isAvailable={category.isAvailable}
            onClick={() => onCategoryClick(category)}
            className={styles.categoryButton}
          />
        ))}
      </div>
    </div>
  );
};

DrugCategoriesIndex.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      letter: PropTypes.string.isRequired,
      isAvailable: PropTypes.bool.isRequired,
      href: PropTypes.string,
      msPath: PropTypes.string,
      title: PropTypes.string,
      sectionId: PropTypes.string,
    }),
  ).isRequired,
  onCategoryClick: PropTypes.func.isRequired,
  activeCategory: PropTypes.string,
};

export default DrugCategoriesIndex;
